import script from "./Step3.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step3.vue?vue&type=script&setup=true&lang=ts"

import "./Step3.vue?vue&type=style&index=0&id=c34c0ba0&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c34c0ba0"]])

export default __exports__